import {productsStep, ProductsStep} from "./products/IvStoreProductsStep";

import {ConfirmStep, confirmStep} from "./confirm/IvStoreConfirmStep";

export default function(parentDir: string) {

    const rootDir =  `${parentDir}/components`;

    return angular.module("tfApp.store.iv.components", [])
                  .component(ProductsStep, productsStep(rootDir))
                  .component(ConfirmStep, confirmStep(rootDir))
                  .name;
}
